/**
 * Вычисляет размеры видео, чтобы оно вписывалось в заданный размер экрана, сохраняя соотношение сторон 16:9.
 *
 * @param screenWidth - Ширина экрана в пикселях.
 * @param screenHeight - Высота экрана в пикселях.
 * @returns Объект, содержащий вычисленные `width` и `height` видео в пикселях.
 */
export function calculateVideoDimensions(screenWidth: number, screenHeight: number) {
  const aspectRatio = 16 / 9;

  // Вычисляем ширину и высоту видео
  let videoWidth = screenWidth;
  let videoHeight = videoWidth / aspectRatio;

  // Если высота видео больше высоты экрана, корректируем размеры
  if (videoHeight > screenHeight) {
    videoHeight = screenHeight;
    videoWidth = videoHeight * aspectRatio;
  }

  return { width: videoWidth, height: videoHeight };
}
